
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-gallery",
      function () {
        return require("private-next-pages/video-gallery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-gallery"])
      });
    }
  